module.exports = __webpack_public_path__ + "img/hj.6134b005.png";